var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIconModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.141,
    height: 14.143
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#17bed0",
    d: "M.71 7.778a1 1 0 010-1.415L6.366.707a1 1 0 011.415 0 1 1 0 010 1.414L2.83 7.07l4.95 4.95a1 1 0 010 1.413 1 1 0 01-1.415 0z"
  })));
}
export default SvgBackIconModal;